import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const DoubleChevronRightIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M3.6323 4.27972C3.8268 4.08597 4.14207 4.08597 4.33658 4.27972L7.65662 7.58689C7.85112 7.78064 7.85112 8.09469 7.65662 8.28844L4.33658 11.5966C4.14212 11.7901 3.82676 11.7901 3.6323 11.5966C3.43785 11.4029 3.43796 11.0888 3.6323 10.895L6.6002 7.93766L3.6323 4.98127C3.43779 4.78752 3.43779 4.47347 3.6323 4.27972Z"
      fill="currentColor"
    />
    <path
      d="M8.2808 4.27972C8.4753 4.08597 8.79058 4.08597 8.98508 4.27972L12.3051 7.58689C12.4996 7.78064 12.4996 8.09469 12.3051 8.28844L8.98508 11.5966C8.79062 11.7901 8.47526 11.7901 8.2808 11.5966C8.08635 11.4029 8.08646 11.0888 8.2808 10.895L11.2487 7.93766L8.2808 4.98127C8.0863 4.78752 8.0863 4.47347 8.2808 4.27972Z"
      fill="currentColor"
    />
  </svg>
);
